<div *ngIf="initComplete" [ngClass]="{ readOnly: (readOnly | async) }">
  <ul
    ngbNav
    [animation]="false"
    #nav="ngbNav"
    class="nav-tabs"
    (navChange)="onNavChange($event)"
    [(activeId)]="nav.activeId">
    <li
      ngbNavItem
      [ngbNavItem]="'personal-details-tab'"
      id="personal-details-tab"
      [disabled]="!authService.canRead('employee_personal_details_tab')">
      <a ngbNavLink class="tab-title">Personal Details</a>
      <ng-template ngbNavContent>
        <app-personal-details-tab #personalDetailsTab></app-personal-details-tab>
      </ng-template>
    </li>
    <li
      ngbNavItem
      [ngbNavItem]="'job-details-tab'"
      id="job-details-tab"
      [disabled]="!authService.canRead('employee_job_details_tab')">
      <a ngbNavLink class="tab-title">Job Details</a>
      <ng-template ngbNavContent>
        <app-job-details-tab #jobDetailsTab></app-job-details-tab>
      </ng-template>
    </li>
    <li
      ngbNavItem
      [ngbNavItem]="'earnings-and-deductions-tab'"
      id="earnings-and-deductions-tab"
      [disabled]="!authService.canRead('employee_earnings_deductions_tab')">
      <a ngbNavLink class="tab-title">Earnings & Deductions</a>
      <ng-template ngbNavContent>
        <app-earnings-and-deductions-tab></app-earnings-and-deductions-tab>
      </ng-template>
    </li>
    <li
      ngbNavItem
      [ngbNavItem]="'taxes-tab'"
      id="taxes-tab"
      [disabled]="!authService.canRead('employee_taxes_tab') || (isNonW2Employee | async)">
      <a ngbNavLink class="tab-title">Taxes</a>
      <ng-template ngbNavContent>
        <app-taxes-tab #taxesTab></app-taxes-tab>
      </ng-template>
    </li>
    <li
      ngbNavItem
      [ngbNavItem]="'benefits-tab'"
      id="benefits-tab"
      [disabled]="
        !authService.canRead('employee_benefits_tab') ||
        (ptoConfigs | async).length === 0 ||
        !(isPersonRecordComplete | async)
      ">
      <a ngbNavLink class="tab-title">Benefits </a>
      <ng-template ngbNavContent>
        <app-benefits-tab></app-benefits-tab>
      </ng-template>
    </li>
    <li
      ngbNavItem
      [ngbNavItem]="'direct-deposit-tab'"
      id="direct-deposit-tab"
      [disabled]="
        !authService.canRead('employee_direct_deposit_tab') ||
        !(allowDirectDeposits | async) ||
        !(isPersonRecordComplete | async)
      ">
      <a ngbNavLink class="tab-title">Direct Deposit</a>
      <ng-template ngbNavContent>
        <app-payment-details-tab> </app-payment-details-tab>
      </ng-template>
    </li>
    <li
      ngbNavItem
      [ngbNavItem]="'audit-log-tab'"
      id="audit-log-tab"
      [disabled]="mode === 'add'"
      *ngIf="!editViaPayrollGrid && !isEmployeePortal">
      <a ngbNavLink class="tab-title">Audit Log</a>
      <ng-template ngbNavContent>
        <app-audit-log-tab [person]="person | async"></app-audit-log-tab>
      </ng-template>
    </li>
    <ng-container *ngIf="isEmployeePortal && canSubmitRequests">
      <li ngbNavItem [ngbNavItem]="'request-history-tab'" id="request-history-tab">
        <a ngbNavLink class="tab-title">Request History</a>
        <ng-template ngbNavContent>
          <lib-employee-request-history
            [person]="person | async"
            [clientCode]="clientCode"></lib-employee-request-history>
        </ng-template>
      </li>
    </ng-container>
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</div>
